/**
 * Asynchronously loads the component for Batch
 */

import { lazyLoad } from 'utils/loadable';

export const Dashboard = lazyLoad(
  () => import('./index'),
  module => {
    return module.Dashboard;
  },
);
